import React, { useState } from "react"
import { ArrowRightIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";

export default function Pagination({ postsPerPage, totalPosts, currentPage, paginate }) {
  // console.log(totalPosts)
  const [active, setActive] = useState(currentPage)
  let allPageNumbers = []
  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    allPageNumbers.push(i)
  }
  const next = () => {
    if (active === allPageNumbers.length) return
    else {
      setActive(active + 1)
      paginate(active + 1)
    }
  }

  const previous = () => {
    if (active === 1) return
    else {
      paginate(active - 1)
      setActive(active - 1)
    }
  }

  return (
    <div>
      <button className="flex items-center gap-3 rounded-full text-cyan-500 disabled:opacity-50" disabled={active === 1} onClick={previous}>
        <ArrowLeftIcon strokeWidth={2} className="h-5 w-5" />Previous
      </button>
      <div className="px-2 space-x-2">
        {allPageNumbers.map((page, index) => (
          <button key={index} onClick={(e) => { paginate(page); setActive(page); }} className=" bg-cyan-500 space-x-4 rounded-full w-8 h-8">{page}</button>
        ))}
      </div>
      <button className="flex items-center gap-3 rounded-full text-blue-500 disabled:opacity-50" disabled={active >= allPageNumbers.length} onClick={next}>
        <ArrowRightIcon strokeWidth={2} className="h-5 w-5" />Next
      </button>
    </div>
  )
}
